
import { defineComponent } from "vue";
import { ref } from "vue";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "OrderPassengersCard",
  components: {
    Button,
    Skeleton,
  },
  props: ["order", "codeDepRus", "codeArrRus", "time"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const routeDate = ref(null);
    // const codeDepRus = ref(null);
    // const codeArrRus = ref(null);
    const nameDep = ref("");
    const nameArr = ref("");
    const schedule = ref(null);
    const newSchedule = ref(null);
    const router = useRouter();
    const route = useRoute();
    // const getSchedule = async () => {
    //   isLoading.value = true;
    //   try {
    //     const json = await axioCred.get(
    //       `https://www.biletdv.ru/customer/IBEServices/GetAeroexpressSchedule?guid=${props.order}`
    //     );
    //     let fetchedPass = await json.data;
    //     schedule.value = fetchedPass;
    //     console.log(schedule.value);
    //     isLoading.value = false;
    //   } catch (err) {
    //     error.value = err;
    //     console.log(error.value);
    //   }
    // };
    const getNewSchedule = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/AeroexpressGetSchedule?departure=${props.codeDepRus}&arrival=${props.codeArrRus}&date=${props.time}`
        );
        let fetchedPass = await json.data;
        newSchedule.value = fetchedPass;
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      schedule,
      routeDate,
      getNewSchedule,
      newSchedule,
      // codeDepRus,
      // codeArrRus,
      nameDep,
      nameArr,
    };
  },
  data() {
    return {};
  },
  computed: {
    getDepName(): any {
      return this.$route.params.nameDep;
    },
    getArrName(): any {
      return this.$route.params.nameArr;
    },
  },
  methods: {
    getDate(date: any) {
      let month = [
        "Января",
        "Февраля",
        "Марта",
        "Апреля",
        "Мая",
        "Июня",
        "Июля",
        "Августа",
        "Сентября",
        "Октября",
        "Ноября",
        "Декабря",
      ];

      let monthNum = new Date(date);
      return (
        monthNum.getDate() +
        " " +
        month[monthNum.getMonth()] +
        " " +
        monthNum.getFullYear()
      );
    },
    pushBack() {
      this.$router.back();
    },
    getDotDate(date: any) {
      let dotDate;
      let fullDate = new Date(date);
      let day = fullDate.getDate();
      let month = fullDate.getMonth();
      let fullMonth;
      let year = fullDate.getFullYear();
      if (month < 10) {
        fullMonth = "0" + month;
      } else {
        fullMonth = month;
      }
      dotDate = day + "." + fullMonth + "." + year;
      return dotDate;
    },
    apropDay(routeDay: string, aeroTime: string) {
      let toCompareDate1 = new Date(routeDay);
      let toCompareDate2 = new Date(aeroTime);
      if (
        toCompareDate1.getUTCFullYear() == toCompareDate2.getUTCFullYear() &&
        toCompareDate1.getUTCMonth() == toCompareDate2.getUTCMonth() &&
        toCompareDate1.getUTCDate() == toCompareDate2.getDate()
      ) {
        return true;
      } else {
        return false;
      }
      // return compone + " " + comptwo
    },
    // checkCodeDep() {
    //   if (this.getCodeDepRus) {
    //     this.codeDepRus = this.getCodeDepRus;
    //   } else {
    //     return
    //   }
    // },
    // checkCodeArr() {
    //   if (this.getCodeArrRus) {
    //     this.codeArrRus = this.getCodeArrRus;
    //   } else {
    //     return
    //   }
    // },
    checkNameDep() {
      if (this.getDepName) {
        this.nameDep = this.getDepName;
      } else {
        if (this.codeDepRus == "ДМД") {
          this.nameDep = "Домодедово";
        } else if (this.codeDepRus == "ШРМ") {
          this.nameDep = "Шереметьево";
        } else if (this.codeDepRus == "ВНК") {
          this.nameDep = "Внуково";
        } else if (this.codeDepRus == "ПВК") {
          this.nameDep = "Павелецкий вокзал";
        } else if (this.codeDepRus == "БСЖ") {
          this.nameDep = "Белорусский вокзал";
        } else if (this.codeDepRus == "КВЖ") {
          this.nameDep = "Киевский вокзал";
        } else {
          return;
        }
      }
    },
    checkNameArr() {
      if (this.getArrName) {
        this.nameArr = this.getArrName;
      }
      {
        if (this.codeArrRus == "ДМД") {
          this.nameArr = "Домодедово";
        } else if (this.codeArrRus == "ШРМ") {
          this.nameArr = "Шереметьево";
        } else if (this.codeArrRus == "ВНК") {
          this.nameArr = "Внуково";
        } else if (this.codeArrRus == "ПВК") {
          this.nameArr = "Павелецкий вокзал";
        } else if (this.codeArrRus == "БСЖ") {
          this.nameArr = "Белорусский вокзал";
        } else if (this.codeArrRus == "КВЖ") {
          this.nameArr = "Киевский вокзал";
        } else {
          return;
        }
      }
    },
  },

  created() {
    this.checkNameDep();
    this.checkNameArr();
    this.getNewSchedule();
  },
});
